module.exports = __webpack_public_path__ + "img/servidores-services.1e0b4e09.jpg";